'use client';

import { useEffect, useState } from 'react';
import AnimatedLogo from '@/components/AnimatedLogo';

// Le logo (accéléré dans workspace.css) a fini de se dessiner vers 1,45 s.
const MINIMUM = 1600;
const FADE = 500;
const NAME = 'Argos';
export const READY_EVENT = 'argos:dashboard-ready';
// Posé par le formulaire de connexion juste avant la redirection : l'accueil ne se joue qu'une
// fois par connexion, jamais au rechargement ni au retour sur un onglet déjà connecté.
export const WELCOME_KEY = 'argos:welcome';

// L'arrivée depuis /login est une navigation côté client : ce composant est alors rendu dans le
// navigateur dès la première image, sans HTML serveur à hydrater ni flash du dashboard.
function welcomePending() {
  try {
    return typeof window !== 'undefined' && sessionStorage.getItem(WELCOME_KEY) === '1';
  } catch {
    return false;
  }
}

export default function DashboardSplash() {
  const [phase, setPhase] = useState(() => (welcomePending() ? 'shown' : 'gone'));

  const visible = phase !== 'gone';

  useEffect(() => {
    if (!visible) return undefined;
    try {
      sessionStorage.removeItem(WELCOME_KEY);
    } catch {}
    let readyTimer = 0;
    let fadeTimer = 0;
    const started = Date.now();

    const leave = () => {
      window.removeEventListener(READY_EVENT, leave);
      readyTimer = window.setTimeout(() => {
        setPhase('leaving');
        fadeTimer = window.setTimeout(() => setPhase('gone'), FADE);
      }, Math.max(0, MINIMUM - (Date.now() - started)));
    };

    // Le shell a pu se monter dans le même rendu que nous : son événement est alors déjà parti.
    if (document.querySelector('[data-dashboard-shell]')) leave();
    else window.addEventListener(READY_EVENT, leave);

    return () => {
      window.removeEventListener(READY_EVENT, leave);
      window.clearTimeout(readyTimer);
      window.clearTimeout(fadeTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="dashboard-splash" data-leaving={phase === 'leaving' ? '' : undefined} role="status">
      <div className="dashboard-splash__lockup" aria-hidden="true">
        <AnimatedLogo className="dashboard-splash__logo" />
        <span className="dashboard-splash__name">
          {NAME.split('').map((letter, index) => (
            <span key={index} style={{ '--i': index }}>
              {letter}
            </span>
          ))}
        </span>
      </div>
      <span className="sr-only">Loading your dashboard…</span>
    </div>
  );
}
